import { ReactElement } from 'react';
import NetworkIcon from '@components/NetworkIcon';
import ThreeDotLoader from '@components/ThreeDotLoader';
import TokenBadge from '@components/TokenBadge';
import { Network } from '@types';
import { shortenAddress } from '@lib/utils';

interface TransferTransactionSummaryProps {
  address: string;
  feeAmount: string;
  isLoading: boolean;
  receiveAmount: string;
  symbol: string;
  toNetwork: Network;
}

function TransferTransactionSummary({
  address,
  feeAmount,
  isLoading,
  receiveAmount,
  symbol,
  toNetwork,
}: TransferTransactionSummaryProps): ReactElement {
  return (
    <div className="rounded-medium bg-transferTransactionSummaryBackground text-white text-body py-2 px-3">
      <div className="flex flex-row justify-between mb-1">
        <p>Bridge network fees:</p>
        {isLoading ? (
          <ThreeDotLoader className="w-6" />
        ) : (
          <p className="font-semibold">{feeAmount}</p>
        )}
      </div>
      <div className="flex flex-row justify-between mb-1">
        <p>You will receive:</p>
        {isLoading ? (
          <ThreeDotLoader className="w-6" />
        ) : (
          <p className="font-semibold flex flex-row">
            {symbol && (
              <TokenBadge
                toNetwork={toNetwork}
                symbol={symbol}
                className="mr-1"
              />
            )}
            {receiveAmount}
          </p>
        )}
      </div>
      <div className="flex flex-row justify-between">
        <p>At address:</p>
        <p className="font-semibold">
          <span className="flex flex-row items-center">
            <span className="mr-1">
              <NetworkIcon className="h-3 w-3" variant={toNetwork} />
            </span>
            {shortenAddress(address)}
          </span>
        </p>
      </div>
    </div>
  );
}

export default TransferTransactionSummary;
